import React from 'react';
import './Team.css';

const Team = () => {
  const teamData = [
    {
      name: "Wen-Ren Yang",
      role: "Chief",
      image: "https://i.postimg.cc/50tghsRV/prof1.jpg",
      linkedIn: "https://www.linkedin.com/in/wry87c?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      name: "JohnSon",
      role: "Member",
      image: "https://i.postimg.cc/Jn3zSPbS/Whats-App-Image-2024-12-18-at-13-59-35-df0a6f2b.jpg",
      linkedIn: "https://www.instagram.com/liu1054250?igsh=M21ob2FjbmU1aWV5",
    },
    {
      name: "Eric",
      role: "Member",
      image: "https://i.postimg.cc/jSQK52DQ/Erik.jpg",
      linkedIn: "",
    },
    {
      name: "Gorden",
      role: "Member",
      image: "https://i.postimg.cc/nLFxQx78/gorden1.jpg",
      linkedIn: "https://github.com/balaboom123",
    },
    {
      name: "Brian",
      role: "Member",
      image: "https://i.postimg.cc/XX6SN63z/bran.jpg",
      linkedIn: "",
    },
    {
      name: "KUEIY-YO",
      role: "Member",
      image: "https://i.postimg.cc/L6fRtjWt/bro1.jpg",
      linkedIn: "https://github.com/coconut341",
    },
    {
      name: "YI-CHEN",
      role: "Member",
      image: "https://i.postimg.cc/L5qvY81t/bro.jpg",
      linkedIn: "https://github.com/coconut341",
    },
  ];

  return (
    <div id='team' className="team-section">
      <div className="container">
        <h2>Our Team</h2>
        <div className="team-grid">
          {teamData.map((member, index) => (
            <div key={index} className="team-member">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <div>
                <a 
                  href={member.linkedIn || "#"}
                  className="anchortag"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {member.role}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
